import React from 'react';
import clsx from 'clsx';
import { STATUS_LABELS, STATUS_COLORS } from '@utils/statusUtils';
import styles from './StatusChart.module.css';

interface StatusData {
  status: string;
  count: number;
}

interface SchedulerStatusChartProps {
  data: StatusData[];
  isLoading: boolean;
}

// Scheduler status chart shows data for ALL CONTRACTS (not filtered by user)
const SchedulerStatusChart: React.FC<SchedulerStatusChartProps> = ({ data, isLoading }) => {
  if (isLoading) {
    return (
      <div className={styles.statusChartContainer}>
        <div className={styles.chartHeader}>
          <h3>Contract Status Distribution</h3>
        </div>
        <div className={clsx(styles.statusChart, styles.loading)}>
          <div className={styles.chartSkeleton}>
            {[1, 2, 3, 4].map(i => (
              <div key={`skeleton-${i}`} className={styles.skeletonBar} style={{ height: `${30 + (i * 15)}%` }}></div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  const total = data.reduce((sum, item) => sum + item.count, 0);


  const sortedData = [...data].sort((a, b) => b.count - a.count);

  return (
    <div className={styles.statusChartContainer}>
      <div className={styles.chartHeader}>
        <h3>Contract Status Distribution</h3>
        <p>System-wide data across all schedulers • {total} total contracts</p>
      </div>
      
      <div className={styles.statusChart}>
        <div className={styles.chartBars}>
          {sortedData.map((item) => {
            const percentage = total > 0 ? (item.count / total) * 100 : 0;
            const color = STATUS_COLORS[item.status] || '#6b7280';
            const label = STATUS_LABELS[item.status] || item.status;
            
            return (
              <div key={item.status} className={styles.statusBarContainer}>
                <div className={styles.statusBarInfo}>
                  <div className={styles.statusLabel}>
                    <div 
                      className={styles.statusColorDot} 
                      style={{ backgroundColor: color }}
                    ></div>
                    {label}
                  </div>
                  <div className={styles.statusCount}>
                    {item.count} ({percentage.toFixed(1)}%)
                  </div>
                </div>
                <div className={styles.statusBarTrack}>
                  <div 
                    className={styles.statusBarFill}
                    style={{ 
                      width: `${percentage}%`,
                      backgroundColor: color
                    }}
                  ></div>
                </div>
              </div>
            );
          })}
        </div>

        {sortedData.length === 0 && (
          <div className={styles.emptyChart}>
            <p>No contract data available</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default SchedulerStatusChart;

